// extracted by mini-css-extract-plugin
export default {"header":"page-header_header__5UyWH","headerContent":"page-header_headerContent__pzLYm","title":"page-header_title__kdRIL"};